import React from 'react'
import DrawPolygonLayer from '../Leaflet/DrawPolygonLayer'
import { withTheme } from '@material-ui/core/styles'


const SelectWithPolygonLayer = ({ active, onComplete, theme }) => (
	active ? <DrawPolygonLayer onComplete={onComplete} color={theme.palette.secondary.main} /> : null
)

export default withTheme()(SelectWithPolygonLayer)



// WEBPACK FOOTER //
// ./src/components/Map/SelectWithPolygonLayer.js